import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import SEOMeta from '@/components/base/SEOMeta';
import { categories, getHotComics, getLatestComics } from '@/mocks/comics';

export default function Home() {
  const hotComics = getHotComics();
  const latestComics = getLatestComics();

  const heroBgUrl = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20background%20with%20soft%20watercolor%20texture%20warm%20pastel%20colors%20artistic%20comic%20illustration%20elements%20subtle%20line%20drawings%20ethereal%20atmosphere%20abstract%20gentle%20gradient%20clean%20minimal%20design%20aesthetic&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape';

  const faqData = [
    {
      question: '韩漫网是什么？',
      answer: '韩漫网是专注于韩国漫画的中文在线阅读导航平台，为您提供海量优质韩漫资源，支持免费在线阅读，每日更新最新韩漫内容。无论您是喜欢恋爱、奇幻、动作、悬疑还是耽美题材，韩漫网都能满足您的阅读需求。',
    },
    {
      question: '韩漫网如何免费看韩漫？',
      answer: '韩漫网提供便捷的韩漫在线阅读服务，您可以直接在网站上浏览和阅读漫画内容。所有漫画按照分类整理，支持下拉式阅读体验，无需注册即可免费观看海量韩漫资源。',
    },
    {
      question: '韩漫网更新频率如何？',
      answer: '韩漫网每日更新，紧跟韩国漫画最新连载进度。连载中的漫画会及时同步最新章节，已完结的漫画提供全集阅读。您可以在最新更新栏目中找到每日更新的韩漫内容。',
    },
    {
      question: '韩漫网支持哪些类型的韩漫？',
      answer: '韩漫网涵盖恋爱、奇幻、动作、悬疑、耽美、都市等多种分类，满足不同读者的喜好。每个分类下都有大量精选漫画，您可以通过分类导航快速找到感兴趣的漫画作品。',
    },
    {
      question: '韩漫网的漫画可以下载吗？',
      answer: '韩漫网目前提供在线免费阅读服务，支持下拉式流畅阅读体验。您可以随时在网站上阅读喜欢的韩漫作品，所有内容均为在线阅读模式。',
    },
  ];

  const statsData = [
    { label: '收录漫画', value: '5000+' },
    { label: '每日更新', value: '200+' },
    { label: '注册用户', value: '180万' },
    { label: '月阅读量', value: '5000万' },
  ];

  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫网 - 韩漫网站与漫画韩漫网址 | 韩漫网官网首页入口免费看韩漫',
    description: '韩漫网官方首页入口，提供漫画韩漫网址直达与韩漫网站导航，支持下拉式免费阅读、全集韩漫在线看，轻松追更热门完结韩漫。',
    url: 'https://www.hanmanwang.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫网',
      url: 'https://www.hanmanwang.com',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question' as const,
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer' as const,
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOMeta
        title="韩漫网 - 韩漫网站与漫画韩漫网址"
        description="韩漫网官方首页入口，提供漫画韩漫网址直达与韩漫网站导航，支持下拉式免费阅读、全集韩漫在线看，轻松追更热门完结韩漫。"
        keywords="韩漫网,韩漫网站,漫画韩漫网址,虚空韩漫网,韩漫网官网,韩漫网首页,韩漫免费,韩漫在线"
        canonicalUrl="https://www.hanmanwang.com/"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src={heroBgUrl}
              alt="韩漫网 - 韩漫在线阅读平台"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
              <div className="text-center max-w-3xl">
                <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 leading-tight">
                  韩漫网 - 免费在线看韩漫
                </h2>
                <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
                  韩漫网官方首页入口，提供漫画韩漫网址直达，支持下拉式免费阅读、全集韩漫在线看，轻松追更热门完结韩漫
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/remen"
                    className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    开始阅读
                  </Link>
                  <Link
                    to="/category/wanjie"
                    className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full font-medium text-sm md:text-base hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    完结韩漫
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
                {statsData.map((stat, index) => (
                  <div key={index} className="text-center p-4 md:p-6 rounded-lg bg-background-100">
                    <p className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{stat.value}</p>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-8 md:py-12">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门推荐</h2>
                  <p className="mt-1 text-sm text-foreground-500">最受读者欢迎的韩漫作品</p>
                </div>
                <Link
                  to="/category/remen"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
                >
                  查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
                {hotComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} size="large" />
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-8 md:py-12 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">漫画分类</h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group p-4 md:p-5 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer"
                  >
                    <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                      <i className="ri-book-open-line text-secondary-600 text-lg w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <h3 className="font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                      {cat.name}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{cat.description}</p>
                    <p className="mt-2 text-xs text-foreground-400">{cat.count}部作品</p>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-8 md:py-12">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新更新</h2>
                  <p className="mt-1 text-sm text-foreground-500">每日同步更新最新韩漫章节</p>
                </div>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
                {latestComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-8 md:py-12 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">常见问题</h2>
              <p className="text-sm text-foreground-500 text-center mb-8">关于韩漫网的常见问题解答</p>
              <div className="space-y-3">
                {faqData.map((item, index) => (
                  <details key={index} className="group rounded-lg bg-background-50 overflow-hidden">
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                      <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</h4>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">加入韩漫网</h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6">立即开始免费阅读海量韩漫，每日更新不容错过</p>
              <Link
                to="/category/remen"
                className="inline-block px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即阅读
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}